if (!customElements.get("custom-select")) {
    class t extends HTMLElement {
        constructor() {
            super(),
            this.initialized = !1,
            this.listboxOpen = !1,
            this.focusedClass = "is-focused"
        }

        connectedCallback() {
            if (!this.initialized) {
                if (
                    this.button = this.querySelector(".custom-select__btn"),
                    this.listbox = this.querySelector(".custom-select__listbox"),
                    !this.button || !this.listbox
                ) {
                    console.error("CustomSelect: Missing button or listbox");
                    return;
                }

                if (
                    this.options = this.querySelectorAll(".custom-select__option"),
                    !this.options.length
                ) {
                    console.error("CustomSelect: No options found");
                    return;
                }

                this.nativeSelect = document.getElementById(`${this.id}-native`);
                this.swatches = this.options[0] && "swatch" in this.options[0].dataset;

                // CHANGED:
                // Do not automatically select first real option
                this.selectedOption = this.querySelector('[aria-selected="true"]');

                this.buttonClickHandler = this.handleButtonClick.bind(this);
                this.keydownHandler = this.handleKeydown.bind(this);
                this.outsideClickHandler = this.handleOutsideClick.bind(this);

                this.button.addEventListener("click", this.buttonClickHandler);
                this.addEventListener("keydown", this.keydownHandler);
                document.addEventListener("click", this.outsideClickHandler);

                this.initialized = !0;
            }
        }

        disconnectedCallback() {
            document.removeEventListener("click", this.outsideClickHandler);
            this.button?.removeEventListener("click", this.buttonClickHandler);
            this.removeListboxOpenListeners();
        }

        handleButtonClick(t) {
            t.preventDefault();
            t.stopPropagation();
            this.listboxOpen ? this.hideListbox() : this.showListbox();
        }

        handleOutsideClick(t) {
            this.listboxOpen && !this.contains(t.target) && this.hideListbox();
        }

        addListboxOpenListeners() {
            this.mouseoverHandler = this.handleMouseover.bind(this);
            this.mouseleaveHandler = this.handleMouseleave.bind(this);
            this.clickHandler = this.handleClick.bind(this);

            this.listbox.addEventListener("mouseover", this.mouseoverHandler);
            this.listbox.addEventListener("mouseleave", this.mouseleaveHandler);
            this.listbox.addEventListener("click", this.clickHandler);
        }

        removeListboxOpenListeners() {
            this.mouseoverHandler &&
                this.listbox.removeEventListener("mouseover", this.mouseoverHandler);

            this.mouseleaveHandler &&
                this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler);

            this.clickHandler &&
                this.listbox.removeEventListener("click", this.clickHandler);
        }

        showListbox() {
            if (!this.listboxOpen) {
                this.listbox.hidden = !1;
                this.listboxOpen = !0;

                this.classList.add("is-open");
                this.button.setAttribute("aria-expanded", "true");
                this.listbox.setAttribute("aria-hidden", "false");

                this.addListboxOpenListeners();

                this.focusOption(this.selectedOption || this.options[0]);

                requestAnimationFrame(() => {
                    this.listbox.focus();
                });
            }
        }

        hideListbox() {
            if (this.listboxOpen) {
                this.removeListboxOpenListeners();

                this.listbox.hidden = !0;
                this.listboxOpen = !1;

                this.classList.remove("is-open");

                this.button.setAttribute("aria-expanded", "false");
                this.listbox.setAttribute("aria-hidden", "true");

                this.focusedOption &&
                    this.focusedOption.classList.remove(this.focusedClass);
            }
        }

        handleMouseover(t) {
            let e = t.target.closest(".custom-select__option");
            e && this.focusOption(e);
        }

        handleMouseleave() {
            this.selectedOption && this.focusOption(this.selectedOption);
        }

        handleClick(t) {
            let e = t.target.closest(".custom-select__option");
            e && this.selectOption(e);
        }

        handleKeydown(t) {
            if (this.listboxOpen)
                switch (t.key) {
                    case "ArrowDown":
                        t.preventDefault();
                        this.focusNext();
                        break;

                    case "ArrowUp":
                        t.preventDefault();
                        this.focusPrevious();
                        break;

                    case "Enter":
                    case " ":
                        t.preventDefault();
                        this.focusedOption &&
                            this.selectOption(this.focusedOption);
                        break;

                    case "Escape":
                        t.preventDefault();
                        this.hideListbox();
                }
        }

        focusNext() {
            if (!this.focusedOption) return;

            let t = this.focusedOption.nextElementSibling;
            t && this.focusOption(t);
        }

        focusPrevious() {
            if (!this.focusedOption) return;

            let t = this.focusedOption.previousElementSibling;
            t && this.focusOption(t);
        }

        focusOption(t) {
            if (t) {
                this.focusedOption &&
                    this.focusedOption.classList.remove(this.focusedClass);

                this.focusedOption = t;
                this.focusedOption.classList.add(this.focusedClass);
            }
        }

        selectOption(t) {
            if (!t) return;

            this.selectedOption &&
                this.selectedOption.setAttribute("aria-selected", "false");

            t.setAttribute("aria-selected", "true");

            this.selectedOption = t;

            let e = t.querySelector("span");

            e &&
                this.button.firstElementChild &&
                (this.button.firstElementChild.textContent =
                    e.textContent.trim());

            this.listbox.setAttribute("aria-activedescendant", t.id);

            this.swatches &&
                t.dataset.swatch &&
                (this.button.dataset.swatch = t.dataset.swatch);

            if (this.nativeSelect) {
                this.nativeSelect.value = t.dataset.value || "";

                this.nativeSelect.dispatchEvent(
                    new Event("change", {
                        bubbles: !0
                    })
                );
            } else {
                this.dispatchEvent(
                    new CustomEvent("change", {
                        bubbles: !0,
                        detail: {
                            selectedValue: t.dataset.value || ""
                        }
                    })
                );
            }

            this.hideListbox();
        }
    }

    customElements.define("custom-select", t);
}